import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { OccupationalHealthServicesBanner } from "../images";

export const OccupationalHealthServices = () => {
    const { t } = useTranslation();
    const keyFeatures = t('occupationalHealthServices.coreServices', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={OccupationalHealthServicesBanner} title={t('occupationalHealthServices.bannerTitle')} />

            <ContentPanel headerText={t('occupationalHealthServices.header')}>
                <h4 className="text-xl mb-5">{t('generic.coreServices')}</h4>

                <UnorderedList items={keyFeatures} />

                <h4 className="text-xl my-5">{t('generic.industriesServed')}</h4>
                <span className="text-white leading-relaxed">{t('occupationalHealthServices.industriesServed')}</span>
            </ContentPanel>
        </div>
    )
}